export default {
  // Modal 标题
  查看物料异常: "查看物料异常",
  编辑物料异常: "编辑物料异常",
  登记物料异常标题: "登记物料异常",

  // 表格列标题
  处理状态: "处理状态",
  物料编号: "物料编号",
  物料名称: "物料名称",
  物料类别: "物料类别",
  二级物料类别: "二级物料类别",
  物料进仓批号: "物料进仓批号",
  供应商编号: "供应商编号",
  "供应商名称（中文）": "供应商名称（中文）",
  "供应商名称（英文）": "供应商名称（英文）",
  相关生产商名称: "相关生产商名称",
  生产批号: "生产批号",
  PO单号: "PO单号",
  发现日期: "发现日期",
  发起人: "发起人",
  发起部门: "发起部门",
  操作: "操作",

  // 状态值
  草稿: "草稿",
  待SCM提交意见: "待SCM提交意见",
  待QA提交意见: "待QA提交意见",
  待通知供应商: "待通知供应商",
  待供应商提供解决方案: "待供应商提供解决方案",
  解决方案审批中: "解决方案审批中",
  已驳回解决方案: "已驳回解决方案",
  已完结: "已完结",
  未知: "未知",

  // 操作按钮
  编辑: "编辑",
  删除: "删除",
  查看: "查看",

  // 搜索字段
  物料: "物料",
  供应商: "供应商",
  请输入物料进仓批号: "请输入物料进仓批号",
  请输入物料名称: "请输入物料名称",
  请输入供应商名称: "请输入供应商名称",
  请选择物料类别: "请选择物料类别",
  请选择处理状态: "请选择处理状态",
  请选择发起人: "请选择发起人",

  // 物料类别级联选项
  生产物料: "生产物料",
  非生产物料: "非生产物料",
  API: "API",
  "輔料（Excipient）": "輔料（Excipient）",
  包材: "包材",
  RLD: "RLD",
  工程建设: "工程建设",
  "设备/设施/仪器": "设备/设施/仪器",
  MRO: "MRO",
  行政物资: "行政物资",
  IT物资: "IT物资",
  外包服务: "外包服务",

  // 列表标题和按钮
  物料异常登记列表: "物料异常登记列表",
  登记物料异常: "登记物料异常",

  // 分页
  共条数据: "共 {{totalCount}} 条数据",

  // 表单标签
  员工姓名: "员工姓名",
  员工工号: "员工工号",
  创建日期: "创建日期",
  部门: "部门",
  岗位: "岗位",
  邮箱: "邮箱",
  异常物料信息: "异常物料信息",
  工厂: "工厂",
  请输入搜索物料编号: "请输入搜索物料编号",
  请输入物料编号搜索: "请输入物料编号搜索",
  请选择物料类别表单: "请选择物料类别表单",
  请选择二级物料类别: "请选择二级物料类别",
  企业类型: "企业类型",
  请选择相关生产商: "请选择相关生产商",
  发现异常日期: "发现异常日期",
  请选择发现日期: "请选择发现日期",
  涉及异常数量: "涉及异常数量",
  是否回仓冻结: "是否回仓冻结",
  请选择通用: "请选择通用",
  回仓或冻结数量: "回仓或冻结数量",
  请输入回仓或冻结数量: "请输入回仓或冻结数量",
  额外工时涉及赔付: "额外工时涉及赔付",
  问题描述: "问题描述",
  请输入问题描述: "请输入问题描述",
  供应商标签照片: "供应商标签照片",
  请上传供应商标签照片: "请上传供应商标签照片",
  相关照片或证明文件: "相关照片或证明文件",
  请上传相关照片或证明文件: "请上传相关照片或证明文件",
  决定退款换货: "决定退款换货",
  请选择决定退款换货: "请选择决定退款换货",
  质量诉求: "质量诉求",
  是否需要调查反馈: "是否需要调查反馈",
  期望解决日期: "期望解决日期",
  请选择期望解决日期: "请选择期望解决日期",
  诉求说明: "诉求说明",
  供应商解决方案: "供应商解决方案",
  备注说明: "备注说明",
  请输入备注说明表单: "请输入备注说明表单",
  审批信息: "审批信息",
  审批意见: "审批意见",
  意见说明: "意见说明",
  同意: "同意",
  驳回: "驳回",
  请输入意见说明: "请输入意见说明",

  // 表单占位符
  请输入员工姓名: "请输入员工姓名",
  请输入员工工号: "请输入员工工号",
  请输入创建日期: "请输入创建日期",
  请输入部门: "请输入部门",
  请输入岗位: "请输入岗位",
  请输入邮箱: "请输入邮箱",
  请输入供应商名称中文: "请输入供应商名称中文",
  请输入供应商名称英文: "请输入供应商名称英文",
  由物料编号自动填写: "由物料编号自动填写",
  由物料进仓批号自动带出: "由物料进仓批号自动带出",

  // 选项值
  代理商: "代理商",
  生产商: "生产商",
  是: "是",
  否: "否",
  退款: "退款",
  换货: "换货",

  // 其他
  单号: "单号",
  点击上传: "点击上传",

  // 消息提示
  请先选择公司和物料编号: "请先选择公司和物料编号",
  获取批号信息失败: "获取批号信息失败",
  获取物料异常登记列表失败: "获取物料异常登记列表失败",
  已登记: "已登记",
  提交失败: "提交失败",
  已暂存: "已暂存",
  暂存失败: "暂存失败",
  已通知供应商: "已通知供应商",
  通知供应商失败: "通知供应商失败",
};
